import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dgbnq7fk3m: FaireBrandEntity = {
  token: "b_dgbnq7fk3m",
  type: "brand",
  name: "Golden Goat Caviar",
  avatarUrl:
    "https://cdn.faire.com/fastly/2c36cdf460b8d33493aa2be052ec5bb209e00c5abc940ecea107f403c3c802d9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b0bd0d5261add9f148aa918ff2694560f1198bae825b8d7e1c3f42dde10aa131.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2c36cdf460b8d33493aa2be052ec5bb209e00c5abc940ecea107f403c3c802d9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b0bd0d5261add9f148aa918ff2694560f1198bae825b8d7e1c3f42dde10aa131.png",
  location: "Miami, FL, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "From Kings and Queens to Grammy Artists and Professional Athletes, Golden Goat supplies the world’s finest caviar to today’s most influential people.  We have scoured the globe to bring you the most exquisite caviar, ensuring that every bite embodies unrivaled flavor, texture, and sophistication.\n\nEvery order is packed by hand to ensure quality and freshness. Please note: We ship Monday through Thursday via next-day air delivery. We do not ship on weekends, and in the event of a holiday, shipments will be processed on the following business day. In rare cases, deliveries may be delayed by one business day.",
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:23:50.552Z",
    importedBy: "entity-db-cli",
  },
};
